/** @file:封装axios文件 */
import Qs from 'qs';
import {
	MessageBox,
	Message
} from 'element-ui';
import axios from 'axios';
import router from '../router/index';
const instance = axios.create({});
instance.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
instance.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 全局添加cancelToken
	Message({
		message: '正在进行数据同步，请耐心等待...',
		center: true,
		iconClass:'el-icon-loading',
		duration:0,
	});
	
	config.data = Qs.stringify(config.data);
	//在请求头部添加参数
	config.headers.post['Access-Token'] = localStorage.getItem("tb_token");
	config.headers.get['Access-Token'] = localStorage.getItem("tb_token");
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 对响应数据做点什么
	// if(response.data.status == 401 && response.data.message == '请先登录后再访问'){
	// 	MessageBox.alert(response.data.message, '提示', {
	// 			confirmButtonText: '确定',
	// 			type: 'warning',
	// 			showClose: false,
	// 			callback: action => {
	// 			console.log(action)
	// 			localStorage.removeItem('token');
	// 			localStorage.removeItem('user_name');
	// 			router.push('/login');
	// 		}
	// 	});
	// }
	Message.closeAll();
	return Promise.resolve(response.data);
}, function (error) {
    if (axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
        return new Promise(() => {});
    } else {
        return Promise.reject(error);
    }
});

export default instance;